import { i18n } from '@/shared/i18n';
import type { TaxonomyStatus } from '@/entities/taxonomy';

/** Status filter tabs. `all` shows every schema regardless of status. */
export type TaxonomyStatusFilter = 'all' | TaxonomyStatus;

export interface TaxonomyStatusTab {
  value: TaxonomyStatusFilter;
  label: string;
}

/**
 * `value` is the filter the list compares against, so it stays a literal; the
 * label is a getter because a resolved string here would freeze at import.
 */
export const TAXONOMY_STATUS_TABS: TaxonomyStatusTab[] = [
  {
    value: 'all',
    get label() {
      return i18n.t('knowledge:taxonomy.constants.allSchemas');
    },
  },
  {
    value: 'published',
    get label() {
      return i18n.t('knowledge:taxonomy.constants.published');
    },
  },
  {
    value: 'draft',
    get label() {
      return i18n.t('knowledge:taxonomy.constants.draft');
    },
  },
  {
    value: 'archived',
    get label() {
      return i18n.t('knowledge:taxonomy.constants.archived');
    },
  },
];
